import { ILibraryQuestion, SourceType as CommonSourceType } from '@aon/tws-common-ui-questions/build/lib/models';
import { IAddedQuestion, SourceType } from '../models';

const convertSourceTypeFromQlToSb = (qlSourceType: CommonSourceType): SourceType => {
	switch (qlSourceType) {
		case CommonSourceType.ClientLibrary:
			return SourceType.Library;
		case CommonSourceType.KincentricLibrary:
			return SourceType.Library;
		case CommonSourceType.Custom:
			return SourceType.Custom;
	}
};

// NOTE: this is less than ideal, but how do we bring "added questions" together with
// ILibraryQuestions from the common lib?
const addedQuestionAsLibraryQuestion = (question: IAddedQuestion): ILibraryQuestion => {
	return {
		...question,
		attributeName: undefined,
		sourceType: question.sourceType === SourceType.Custom ? CommonSourceType.Custom : CommonSourceType.KincentricLibrary,
		alternateVersions: 0,
		showVariations: false,
		languageCount: question.languages?.length,
		benchmarkIds: [],
		questionVariationId: question.questionVariationId || 0,
		scoredDimensionNames: [],
		isDemographic: question.isDemographic,
	};
};

export { addedQuestionAsLibraryQuestion, convertSourceTypeFromQlToSb };
